export default "__VITE_ASSET__jSfP$7no__"